import { imageLoader } from './loader';
import { ImageData, ResponsiveImage, ResponsiveImageProps } from './ResponsiveImage';

// const breakpoints = [320, 464, 640, 750, 828, 960, 1080, 1280, 1668, 1920, 2048, 2560, 3200, 3840];

type ImageProps = Omit<ResponsiveImageProps, 'src'> & {
  src?: string | ImageData | null;
};

export const Image = ({ src, ...props }: ImageProps) => {
  if (!src) {
    return null;
  }

  return <ResponsiveImage src={typeof src == 'object' ? src : imageLoader(src)} {...props} />;
};
